import { addFlashAlert } from "common/components/FlashAlert";
import { checkForUpdate } from "common/services/serviceWorker.service";
import React, { useState } from "react";
import { useLocation } from "react-router";

export const useServiceWorker = () => {
  const location = useLocation();
  const [listenerActivated, setListenerActivated] = useState(false);

  // Methods
  const updateRegistrations = async () => {
    if (process.env.NODE_ENV === "development") {
      return;
    }
    if (!navigator.serviceWorker?.controller) {
      console.error("No service worker controller found.");
    }
    if (navigator.serviceWorker) {
      const regs = await navigator.serviceWorker.getRegistrations();
      regs.forEach((reg) => {
        if (reg.waiting) {
          checkForUpdate(navigator, window, localStorage);
        } else {
          reg.update();
        }
      });
    }
    if (!listenerActivated) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data.type === "ORGS_CACHE_FAILED") {
          console.error("Orgs cache setup failed:", event.data.detail);
          addFlashAlert("danger", "Orgs cache setup failed. Please try again.");
        }

        if (event.data.type === "NEW_VERSION_AVAILABLE") {
          window.location.reload();
        }
      });
      setListenerActivated(true);
    }
  };

  React.useEffect(() => {
    updateRegistrations();
  }, [location]);
};
